import React from "react";
import Hero from "./Hero";
import Newsletter from "./Newsletter";
import Brand from "./Brand";
import FeaturedProduct from "../../container/Product/FeaturedProduct";
import NewlyArrived from "../../container/Product/NewlyArrived";
import PlayStation5 from "./PlayStation5";
import NintendoSwitch from "./NintendoSwitch";
import GiftCards from "./GiftCards";

const Home = () => {
  return (
    <main className="min-h-screen w-full bg-slate-50 overflow-x-hidden">
      <div className="flex flex-col gap-4">
        {/* Hero */}
        <section className="w-full">
          <Hero />
        </section>

        {/* Featured */}
        <section className="w-full">
          <FeaturedProduct />
        </section>

        {/* Newly Arrived */}
        <section className="w-full">
          <NewlyArrived />
        </section>

        {/* Brand sections */}
        <section className="w-full">
          <PlayStation5 />
        </section>

        <section className="w-full">
          <NintendoSwitch />
        </section>


        {/* Brands */}
        <section className="w-full">
          <Brand />
        </section>

        {/* Newsletter */}
        <section className="w-full">
          <Newsletter />
        </section>
      </div>
    </main>
  );
};

export default Home;
